import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import styles from './top-five-countries.module.scss';
import useGeographicDistribution from '../../../../stores/profile/modules/use-geographic-distribution';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const TopFiveCountries = () => {
  const { asOfDate, geographySelected, hideTopFiveCountries, tableData, ticker } =
    useGeographicDistribution({ isTopFiveCountries: true });

  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_TopFiveCountries"
      data-analytics-section="component"
    >
      <CardModule.Header>
        <Row>
          <Col>
            Top 5 Countries
            <CardModule.AsOfDateMedBlock>{format.date(asOfDate)}</CardModule.AsOfDateMedBlock>
          </Col>
        </Row>
      </CardModule.Header>
      <CardModule.Body>
        <Row>
          <Col>
            <TableBasic flush>
              <caption {...className('sr-only')}>
                Top 5 Countries
                {ticker}
              </caption>
              <thead>
                <tr>
                  <th scope="col" {...className('text-left')}>
                    {geographySelected.label}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => {
                  return (
                    <tr
                      data-key={`${row[geographySelected.value] || ''}-${index}`}
                      key={`${row[geographySelected.value] || ''}-${index}`}
                    >
                      <td>
                        {hideTopFiveCountries ? '--' : format.text(row[geographySelected.value])}
                      </td>
                      <td {...className('text-right', 'font-weight-bold')}>
                        {format.text(row[geographySelected.value]) === '--' || hideTopFiveCountries
                          ? '--'
                          : format.percent(row.allocationPercent)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </TableBasic>
          </Col>
        </Row>
      </CardModule.Body>
    </CardModule>
  );
};

export default TopFiveCountries;
